import type { Pilot } from '../physics/Pilot'

/** Re-pulse a little more often than the pulse length, so it never gaps. */
const PULSE_MS = 90
const REPULSE_INTERVAL = 0.07

/**
 * Controller rumble proportional to throttle (DESIGN.md §7). Ten lines, and it
 * sells thrust better than anything else in the build — so it lands in Phase 1,
 * not in a polish pass.
 */
export class Haptics {
  enabled = true
  private nextPulse = 0

  update(session: XRSession | null, pilot: Pilot, dt: number): void {
    this.nextPulse -= dt
    if (!this.enabled || !session || this.nextPulse > 0) return
    this.nextPulse = REPULSE_INTERVAL

    for (const source of session.inputSources) {
      if (source.handedness !== 'left' && source.handedness !== 'right') continue
      const index = source.handedness === 'left' ? 0 : 1
      const actuator = source.gamepad?.hapticActuators?.[0]
      if (!actuator) continue

      const level = pilot.debug.rockets[index].level
      // A crash overrides throttle with a full-strength jolt.
      const intensity = pilot.lastContact === 'crash' ? 1 : level * 0.85
      if (intensity > 0.02) void actuator.pulse(intensity, PULSE_MS)
    }
  }

  /** One-shot confirmation buzz, e.g. on calibration or a successful landing. */
  pulse(session: XRSession | null, intensity: number, ms: number): void {
    if (!this.enabled || !session) return
    for (const source of session.inputSources) {
      void source.gamepad?.hapticActuators?.[0]?.pulse(intensity, ms)
    }
  }
}
